import { Delete } from "@mui/icons-material";
import { Box, IconButton, SxProps } from "@mui/material";
import { FunctionComponent, useState } from "react";
import theme from "styles/theme";
import { Attachment } from "types/Attachment";
import { Cycle } from "types/Cycle";
import { PositionTrolley } from "types/Incident";
import ImageBlobCmp from "../../photo/ImageBlobCmp";
import LayerPositionDialog from "../LayerPositionDialog";
import { getNameLayer } from "./SelectorLayersDialog";



interface Props {
	attachments: Attachment[]
	cycle: Cycle;
	onAttachmentsChange?: (attachments: Attachment[]) => void
}

const IncidentAttachments: FunctionComponent<Props> = ({
	attachments,
	cycle,
	onAttachmentsChange,
}) => {

	// HOOKS

	/** attachment attualmente in editazione */
	const [attachIndex, setAttachIndex] = useState(-1);
	const [attachPosition, setAttachPosition] = useState<PositionTrolley>(null);
	/** dialog per l'editazione del layer per l'attach */
	const [layersDialogOpen, setLayersDialogOpen] = useState(false);


	// HANDLERs

	const handleLayerSelectorOpen = (attach: Attachment, index: number) => {
		setAttachPosition({
			layerId: attach.layer?.layerId,
			layerNumber: attach.layer?.layerNumber,
			positionOfTrolleys: attach.layer?.trolleysPosition,
		})
		setAttachIndex(index)
		setLayersDialogOpen(true)
	}
	const handleLayerSelectorClose = (position: PositionTrolley) => {
		setLayersDialogOpen(false)
		if (position == null) return

		attachments[attachIndex].layer = {
			layerId: position?.layerId,
			layerNumber: position?.layerNumber,
			trolleysPosition: position?.positionOfTrolleys,
		}
		onAttachmentsChange?.([...attachments])
		setAttachIndex(-1)
		setAttachPosition(null)
	}

	const handleDeleteAttachment = (id: number) => {
		onAttachmentsChange?.(attachments.filter(attach => attach.id !== id))
	}


	// RENDER

	return (
		<div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "10px" }}>

			{attachments.map((attach, index) => (

				<Box key={index} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>

					<ImageBlobCmp sx={{ width: 50, height: 50 }}
						attach={attach}
					/>

					<Box sx={sxAttachRow}
						onClick={() => handleLayerSelectorOpen(attach, index)}
					>
						<Box sx={sxAttachName}>{attach.name}</Box>
						<AttachmentLayerInfo cycle={cycle} attach={attach} />
					</Box>

					<IconButton size="small"
						onClick={() => handleDeleteAttachment(attach.id)}
					><Delete /></IconButton>

				</Box>
			))}

			<LayerPositionDialog
				cycle={cycle}
				open={layersDialogOpen}
				positionTrolley={attachPosition}
				//ignoreLayer={layerSelect?.map(l => l.layerNumber) ?? []}
				onClose={handleLayerSelectorClose}
			/>

		</div>
	);
};

export default IncidentAttachments;


const sxAttachRow: SxProps = {
	flex: 1,
	cursor: "pointer",
	display: "flex",
	flexDirection: "column",
	p: "2px 5px",
	borderRadius: "4px",
	"&:hover": {
		bgcolor: "action.hover",
	}
}

const sxAttachName: SxProps = {
	fontSize: 14,
	fontWeight: 400,
	flex: 1,
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
}



interface PropsAttachLayerInfo {
	cycle: Cycle,
	attach: Attachment,
}

const AttachmentLayerInfo: FunctionComponent<PropsAttachLayerInfo> = ({
	cycle,
	attach,
}) => {

	if (!attach.layer) return null;

	const positions = attach.layer.trolleysPosition?.length ? attach.layer.trolleysPosition.join(", ") : "--";
	const layerNumber = attach.layer.layerNumber;
	const layerName = getNameLayer(cycle.growUnitId, layerNumber);
	const phase = cycle?.layers?.find(l => l.layerNumber === layerNumber)?.phase ?? "--";

	return (
		<Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
			<Box sx={sxLayer}>{layerName}</Box>
			<Box sx={sxPhase}>
				{phase}; Position: <span style={{ fontSize: 15, fontWeight: 600 }}> {positions}</span>
			</Box>
		</Box>

	)
}

const sxPhase: SxProps = {
	fontSize: 12,
	fontWeight: 500,
	textTransform: "uppercase",
}
const sxLayer = {
	fontSize: 14,
	fontWeight: 700,
	p: "1px 6px",
	borderRadius: "5px",
	bgcolor: theme.palette.text.main,
	color: theme.palette.text.negative,
}